import IconComponent from "@CubeComponents/icons";
import { Link } from "@mui/material";
import { useTranslation } from "@i18n";

function MobileDeviceRestrict() {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex absolute h-full w-full z-50 flex-col justify-center bg-white text-center  p-6 gap-16">
        <div className="flex flex-col gap-16 items-center justify-center grow">
          <div className="gap-4 flex flex-col items-center justify-center">
            <div className="flex items-center justify-center">
              <IconComponent
                name="DestopViewWarningIllustration"
                className="text-center"
                width="14rem"
                height="14rem"
              />
            </div>
            <div className="text-2xl font-semibold text-text_light text-center mx-7">
              {t("Enjoy a seamless experience with the CUBE app!")}
            </div>
          </div>
          <div className="flex flex-row gap-4 items-center justify-center mx-7">
            <Link href="https://play.google.com/store/apps/details?id=com.prod.cube.ms&hl=en_IN" className="flex-1">
              <IconComponent name="playStoreRedirect" width="10.75rem" height="3.4375rem" />
            </Link>
            <Link href="https://apps.apple.com/us/app/cube-ms/id6504751772" className="flex-1">
              <IconComponent name="appStoreRedirect" width="10.75rem" height="3.375rem" />
            </Link>
          </div>
        </div>
        <div className="text-sm text-text_light">
          {`You can also switch to desktop view by selecting "Request Desktop Website" in browser settings`}
        </div>
      </div>
    </>
  );
}

export default MobileDeviceRestrict;
